var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefect = function SvgDefect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.727 19.66-2.386-2.387 4.773-4.773L5.34 7.727l2.386-2.386 4.773 4.773 4.773-4.773 2.387 2.386-4.773 4.773 4.773 4.773-2.387 2.387-4.773-4.773z",
    clipRule: "evenodd"
  })));
};
export { SvgDefect as ReactComponent };
export default "data:image/svg+xml,%3csvg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7.72703 19.6595L5.34054 17.273L10.1135 12.5001L5.34054 7.72708L7.72703 5.3406L12.5 10.1136L17.273 5.3406L19.6595 7.72708L14.8865 12.5001L19.6595 17.273L17.273 19.6595L12.5 14.8865L7.72703 19.6595Z' fill='%234A6067'/%3e %3c/svg%3e";